
/**
 *
 * @brief specification for the various events we expect to be visible
 * within the loader and to the application, to enable watching of
 * parsed data being ready etc.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2023
 *
 */

export enum FeedbackKind {
  ERROR,
  WARNING,
  INFO,
  DEBUG,
}


export enum EventType {
  START     = 'start',
  PROGRESS  = 'progress',
  COMPLETED = 'completed',
  FAILED    = 'failed',
  FEEDBACK  = 'feedback'
}

/*
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 *
 * EVENTS
 *
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 */

/** Common base interface for all events */
export interface LoaderEvent {

  /** symbolic / kind of event */
  tag: string;

  /** all events have a unique id */
  id: number;

}

/** When reporting failure (could not parse) */
export interface ParsingStartEvent extends LoaderEvent {

  /** the summary message */
  summary: string;

}

/** When reporting errors or warnings */
export interface FeedbackEvent extends LoaderEvent {

  /** is this an error or warning? */
  kind: FeedbackKind;

  /** the details of the feed back */
  text: string;

}

/** When reporting successfully completion */
export interface ParseSuccessEvent extends LoaderEvent {

  /** the summary message */
  summary: string;

  /** time it took to complete (seconds) */
  duration: number;

}

/** When reporting successfully completion */
export interface LoadingProgressEvent extends LoaderEvent {

  /** most recent message */
  summary: string;

  /** the progress (0-100) */
  progress: number;

}


/** When reporting failure (could not parse) */
export interface ParseFailureEvent extends LoaderEvent {

  /** the summary message */
  summary: string;

}

/*
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 *
 * CALLBACKS
 *
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 */

export type StartCallBack        = (event: ParsingStartEvent)    => void;
export type FeedbackCallBack     = (event: FeedbackEvent)        => void;
export type ParseSuccessCallBack = (event: ParseSuccessEvent)    => void;
export type ParseFailureCallBack = (event: ParseFailureEvent)    => void;
export type ProgressCallBack     = (event: LoadingProgressEvent) => void;

export type LoaderCallback = StartCallBack|FeedbackCallBack|ParseFailureCallBack|ParseSuccessCallBack|ProgressCallBack;




